// @flow

import React, { Component } from 'react';
import classnames from 'classnames';

import styles from './SaveSearchPrompt.less';
import SaveIcon from './icons/SaveIcon';
import ConfirmationIcon from './icons/ConfirmationIcon';
import NavLink from 'src/components/NavLink/NavLink';

import { PageBlock, Text, TextLink, Hidden } from 'seek-style-guide/react';
import SaveSearchButton from 'src/components/SaveSearchButton/SaveSearchButton';

import { savedSearchesPath } from 'src/config';

type Props = {
  isSearchSaved?: boolean,
  className?: string
};

const Icon = ({ isSearchSaved }: { isSearchSaved?: boolean }) =>
  isSearchSaved ? <ConfirmationIcon /> : <SaveIcon />;

export default class SaveSearchPrompt extends Component<Props> {
  props: Props;

  getPromptText = () => {
    if (this.props.isSearchSaved) {
      return (
        <span>
          {'We’ve saved your search. '}
          <NavLink component={TextLink} location={savedSearchesPath}>
            Manage&nbsp;your&nbsp;Saved&nbsp;Searches
          </NavLink>
        </span>
      );
    }

    return 'Save this search and get new jobs by email';
  };

  render() {
    const { isSearchSaved, className } = this.props;

    return (
      <PageBlock className={classnames(styles.root, className)}>
        <div className={styles.searchWrapper}>
          <Hidden mobile className={styles.icon}>
            <Icon isSearchSaved={isSearchSaved} />
          </Hidden>
          <Text strong raw baseline={false}>
            {this.getPromptText()}
          </Text>
          {isSearchSaved ? (
            <Hidden desktop className={styles.icon}>
              <Icon isSearchSaved={isSearchSaved} />
            </Hidden>
          ) : (
            <SaveSearchButton
              className={styles.button}
              data-automation="saveSearchButton"
              color="blue"
              saveSearchPosition="sticky"
            >
              Save
            </SaveSearchButton>
          )}
        </div>
      </PageBlock>
    );
  }
}
